import ScrollableRow from "../../../Shared/Components/ProductElements/Containers/ScrollableRow/ScrollableRow";
import styles from "./ScrollableProductSections.module.css";
import { PageText } from "../../Text/Text";

const ScrollableProductSections = ({
  sections = [],
  resultLabel = "results",
  showCount = true,
  emptyState = null,
}) => {
  const visibleSections = sections.filter(section =>
    Array.isArray(section.products) && section.products.length > 0
  );

  if (visibleSections.length === 0) {
    return emptyState;
  }

  return (
    <section className={styles.scrollContainerWrapper}>
      {visibleSections.map((section, idx) => {
        const sectionTitle = section.title || section.subcategory || "";
        const sectionSubtitle = section.subtitle || "";
        const sectionId = section.id || sectionTitle || idx;

        return (
          <div key={sectionId}>
            <section id={sectionId} className={styles.productSectionWrapper}>
              {sectionTitle.length > 0 && (
                <div className={styles.productSectionHeader}>
                  <div className={styles.productTextGroup}>
                    {showCount && (
                      <div className={styles.resultsCountBox}>
                        <span className={styles.countNumber}>
                          {section.products.length}
                        </span>
                        <p className={styles.countText}>{resultLabel}</p>
                      </div>
                    )}

                    <div className={styles.sectionTitleContainer}>
                      <PageText type="heroTitle">{sectionTitle}</PageText>

                      {sectionSubtitle.length > 0 && (
                        <PageText type="heroDescription">{sectionSubtitle}</PageText>
                      )}
                      {section.headerElement && (
                        <div className={styles.headerElementWrapper}>
                          {section.headerElement}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* <div className={styles.productsContainer}>
                <ScrollableRow products={section.products} />
              </div> */}
              <div className={styles.productsInnerContainer}>
                <ScrollableRow products={section.products} />
              </div>
            </section>
          </div>
        );
      })}
    </section>
  );
};

export default ScrollableProductSections;